export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5158.7dc8df31.jpg";